<template>
    <common-chart class="w-100 h-100" :options="options"></common-chart>
</template>

<script>
import CommonChart from "@/components/echarts-part/kpi/stuff/CommonChart.vue";

export default {
    name: "ELogo",
    components: {CommonChart},
    props: {
        title: String
    },
    data() {
        return {
            options: {
                graphic: {
                    elements: [
                        {
                            type: 'text',
                            left: 'center',
                            top: 'center',
                            style: {
                                text: this.title,
                                fontSize: 80,
                                fontWeight: 'bold',
                                lineDash: [0, 200],
                                lineDashOffset: 0,
                                fill: 'transparent',
                                stroke: '#000',
                                lineWidth: 1
                            },
                            keyframeAnimation: {
                                duration: 3000,
                                keyframes: [
                                    {
                                        percent: 0.7,
                                        style: {
                                            fill: 'transparent',
                                            lineDashOffset: 200,
                                            lineDash: [200, 0]
                                        }
                                    },
                                    {
                                        // Stop for a while.
                                        percent: 0.8,
                                        style: {
                                            fill: 'transparent'
                                        }
                                    },
                                    {
                                        percent: 1,
                                        style: {
                                            fill: 'gray'
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
